module.exports = __webpack_public_path__ + "static/img/icon2.8fa50931.png";